import React from 'react';
import { FileText, FileSpreadsheet, Download, BarChart2, TrendingUp, Users, Truck, ChevronRight } from 'lucide-react';
export function ReportingView() {
  return <div className="space-y-6" data-id="element-1486">
      <div className="flex items-center justify-between" data-id="element-1487">
        <div data-id="element-1488">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-1489">Reporting Suite</h2>
          <p className="text-sm text-slate-500" data-id="element-1490">
            Exportable insights and financial summaries
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-1491">
          <button className="flex items-center gap-2 px-4 py-2 bg-emerald-50 text-emerald-600 border border-emerald-100 rounded-xl text-xs font-bold hover:bg-emerald-100 transition-all" data-id="element-1492">
            <FileSpreadsheet size={14} data-id="element-1493" />
            Bulk Export (.xlsx)
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1494">
        <ReportCard title="Weekly Food Cost" desc="Matches Week 1-5 output format" icon={BarChart2} color="emerald" data-id="element-1495" />
        <ReportCard title="P&L Summary" desc="Revenue vs. Expenses (TOTALS)" icon={TrendingUp} color="blue" data-id="element-1496" />
        <ReportCard title="Vendor Spend" desc="Sysco vs. Coastal vs. Others" icon={Truck} color="purple" data-id="element-1497" />
        <ReportCard title="Labor Report" desc="Daily labor cost vs. Sales" icon={Users} color="indigo" data-id="element-1498" />
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-id="element-1499">
        <div className="p-6 border-b border-slate-50" data-id="element-1500">
          <h3 className="text-sm font-bold text-slate-900 uppercase tracking-wider" data-id="element-1501">
            Recent Generated Reports
          </h3>
        </div>
        <div className="divide-y divide-slate-50" data-id="element-1502">
          <ReportRow name="May 2026 P&L Summary" date="May 31, 2026" type="Excel" data-id="element-1503" />
          <ReportRow name="Week 4 Food Cost Analysis" date="May 28, 2026" type="PDF" data-id="element-1504" />
          <ReportRow name="Vendor Spend Recap - Q2" date="May 25, 2026" type="Excel" data-id="element-1505" />
          <ReportRow name="Labor Variance Report" date="May 20, 2026" type="PDF" data-id="element-1506" />
        </div>
      </div>
    </div>;
}
function ReportCard({
  title,
  desc,
  icon: Icon,
  color
}: any) {
  const colors: any = {
    emerald: 'bg-emerald-50 text-emerald-600',
    blue: 'bg-blue-50 text-blue-600',
    purple: 'bg-purple-50 text-purple-600',
    indigo: 'bg-indigo-50 text-indigo-600'
  };
  return <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm hover:border-slate-200 transition-all group cursor-pointer" data-id="element-1507">
      <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${colors[color]}`} data-id="element-1508">
        <Icon size={24} data-id="element-1509" />
      </div>
      <h4 className="text-sm font-bold text-slate-900 mb-1" data-id="element-1510">{title}</h4>
      <p className="text-[10px] text-slate-400 font-medium mb-6" data-id="element-1511">{desc}</p>

      <div className="flex items-center gap-2" data-id="element-1512">
        <button className="flex-1 py-2 bg-slate-50 text-slate-600 rounded-lg text-[10px] font-bold hover:bg-slate-100 transition-all flex items-center justify-center gap-1.5" data-id="element-1513">
          <FileText size={12} data-id="element-1514" /> PDF
        </button>
        <button className="flex-1 py-2 bg-slate-50 text-slate-600 rounded-lg text-[10px] font-bold hover:bg-slate-100 transition-all flex items-center justify-center gap-1.5" data-id="element-1515">
          <FileSpreadsheet size={12} data-id="element-1516" /> Excel
        </button>
      </div>
    </div>;
}
function ReportRow({
  name,
  date,
  type
}: any) {
  return <div className="px-6 py-4 flex items-center justify-between hover:bg-slate-50 transition-colors group cursor-pointer" data-id="element-1517">
      <div className="flex items-center gap-4" data-id="element-1518">
        <div className="w-10 h-10 bg-slate-50 rounded-lg flex items-center justify-center text-slate-400 group-hover:text-slate-600 transition-colors" data-id="element-1519">
          {type === 'Excel' ? <FileSpreadsheet size={18} data-id="element-1520" /> : <FileText size={18} data-id="element-1521" />}
        </div>
        <div data-id="element-1522">
          <p className="text-sm font-bold text-slate-900" data-id="element-1523">{name}</p>
          <p className="text-[10px] text-slate-400 font-medium" data-id="element-1524">
            Generated on {date}
          </p>
        </div>
      </div>
      <button className="p-2 text-slate-300 hover:text-slate-600 transition-colors" data-id="element-1525">
        <Download size={18} data-id="element-1526" />
      </button>
    </div>;
}